import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';
import isEqual from 'lodash.isequal';

// Selectors
// @ts-ignore
import { selectGroupedDataKeys } from 'services/timesheetTimesheetEntriesForm/selectors';

// Components
// @ts-ignore
import TimesheetTimesheetEntriesTableHead from '../TimesheetTimesheetEntriesTableHead';
// @ts-ignore
import TimesheetKeyboardEventsListener from './components/TimesheetKeyboardEventsListener';
// @ts-ignore
import TimesheetTimesheetEntriesTableGrouping from './components/TimesheetTimesheetEntriesTableGrouping';

interface Props {
    ids: string[];
}

export class TimesheetTimesheetEntriesTable extends React.Component<Props> {
    shouldComponentUpdate(nextProps: Props): boolean {
        const { ids } = this.props;

        return !isEqual(ids, nextProps.ids);
    }

    renderTableRows(): React.ReactElement {
        const { ids } = this.props;

        if ((!ids || !ids.length)) {
            return (
                <Table.Row colSpan="17" textAlign="center">
                    <Table.Cell
                        colSpan="17"
                        className="events-table-cell-padding"
                    >
                        There are no timesheet entries. Please create a new one.
                    </Table.Cell>
                </Table.Row>
            );
        }

        return (
            <React.Fragment>
                <TimesheetTimesheetEntriesTableGrouping />
                {ids.map((id: any): React.ReactElement => (
                    <TimesheetTimesheetEntriesTableGrouping
                        key={id}
                        groupingId={id}
                    />
                ))}
            </React.Fragment>
        )
    }

    render(): React.ReactElement {
        return (
            <React.Fragment>
                <TimesheetKeyboardEventsListener />
                <Table
                    sortable
                    celled
                    singleLine
                    unstackable
                    size="small"
                    // HACK inline styles
                    style={{
                        borderTop: 'none',
                        borderRight: 'none',
                        borderLeft: 'none',
                        marginBottom: 40,
                        borderRadius: 0
                    }}
                >
                    <TimesheetTimesheetEntriesTableHead />
                    <Table.Body>
                        {this.renderTableRows()}
                    </Table.Body>
                </Table>
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    ids: selectGroupedDataKeys
});

// @ts-ignore
export default connect(mapStateToProps)(TimesheetTimesheetEntriesTable);
